<template>
  <div class="w-100">
    <div
      v-if="isAdvertiser"
      class="d-flex advertiser-statuses align-items-center flex-wrap"
    >
      <icon-label
        :label="$t(`campaign.status.${aStatuses.under_construction.name}`)"
        :icon="`${this.$publicPath}${aStatuses.under_construction.icon}`"
        :class="aStatusIndex == 0 ? 'bg-warning border-warning' : 'bg-white'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        :label="$t(`campaign.status.${aStatuses.inviting.name}`)"
        :icon="`${this.$publicPath}${aStatuses.inviting.icon}`"
        :class="aStatusIndex == 1 ? 'bg-warning border-warning' : aStatusIndex > 1 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        :label="$t(`campaign.status.${aStatuses.waiting_for_payment.name}`)"
        :icon="`${this.$publicPath}${aStatuses.waiting_for_payment.icon}`"
        :class="aStatusIndex == 2 ? 'bg-warning border-warning' : aStatusIndex > 2 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        :label="$t(`campaign.status.${aStatuses.in_progress.name}`)"
        :icon="`${this.$publicPath}${aStatuses.in_progress.icon}`"
        :class="aStatusIndex == 3 ? 'bg-warning border-warning' : aStatusIndex > 3 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        v-if="aStatusIndex < 5"
        :label="$t(`campaign.status.${aStatuses.completed.name}`)"
        :icon="`${this.$publicPath}${aStatuses.completed.icon}`"
        :class="aStatusIndex == 4 ? 'bg-warning border-warning' : aStatusIndex > 4 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <icon-label
        v-else-if="aStatusIndex == 5"
        :label="$t(`campaign.status.${aStatuses.canceled.name}`)"
        :icon="`${this.$publicPath}${aStatuses.canceled.icon}`"
        class="bg-danger text-white border-danger"
      />
      <icon-label
        v-else-if="aStatusIndex == 6"
        :label="$t(`campaign.status.${aStatuses.interrupted.name}`)"
        :icon="`${this.$publicPath}${aStatuses.interrupted.icon}`"
        class="bg-danger text-white border-danger"
      />
    </div>
    <div
      v-else
      class="d-flex justify-content-start align-items-center flex-wrap"
    >
      <icon-label
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.invited.name}`)"
        :icon="`${this.$publicPath}${iStatuses.invited.icon}`"
        :class="iStatusIndex == 0 ? 'bg-warning border-warning' : 'bg-white'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        v-if="iStatusIndex == 1"
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.invite_rejected.name}`)"
        :icon="`${this.$publicPath}${iStatuses.invite_rejected.icon}`"
        class="bg-danger text-white border-danger"
      />
      <icon-label
        v-if="iStatusIndex > 1"
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.invite_accepted.name}`)"
        :icon="`${this.$publicPath}${iStatuses.invite_accepted.icon}`"
        :class="iStatusIndex == 2 ? 'bg-warning border-warning' : iStatusIndex > 2 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.waiting_for_draft.name}`)"
        :icon="`${this.$publicPath}${iStatuses.waiting_for_draft.icon}`"
        :class="iStatusIndex == 3 ? 'bg-warning border-warning' : iStatusIndex > 3 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.waiting_fot_draft_approval.name}`)"
        :icon="`${this.$publicPath}${iStatuses.waiting_fot_draft_approval.icon}`"
        :class="iStatusIndex == 4 ? 'bg-warning border-warning' : iStatusIndex > 4 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.waiting_fot_publication.name}`)"
        :icon="`${this.$publicPath}${iStatuses.waiting_fot_publication.icon}`"
        :class="iStatusIndex == 5 ? 'bg-warning border-warning' : iStatusIndex > 5 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.waiting_for_publication_approval.name}`)"
        :icon="`${this.$publicPath}${iStatuses.waiting_for_publication_approval.icon}`"
        :class="iStatusIndex == 6 ? 'bg-warning border-warning' : iStatusIndex > 6 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <img
        class="d-inline-block px-3"
        :src="`${$publicPath}img/arrow-right2.svg`"
      >
      <icon-label
        v-if="iStatusIndex <= 6 || iStatusIndex == 9"
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.completed.name}`)"
        :icon="`${this.$publicPath}${iStatuses.completed.icon}`"
        :class="iStatusIndex == 9 ? 'bg-warning border-warning' : iStatusIndex > 9 ? 'bg-white' : 'bg-transparent monochrome'"
      />
      <icon-label
        v-if="iStatusIndex == 7"
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.expired.name}`)"
        :icon="`${this.$publicPath}${iStatuses.expired.icon}`"
        class="bg-danger text-white border-danger"
      />
      <icon-label
        v-if="iStatusIndex == 8"
        :label="$t(`campaignMemberInfluencer.status.${iStatuses.canceled.name}`)"
        :icon="`${this.$publicPath}${iStatuses.canceled.icon}`"
        class="bg-danger text-white border-danger"
      />
    </div>
  </div>
</template>

<script>
import campaignStatuses from './campaign_statuses.js'
import memberStatuses from './member_statuses.js'
import iconLabel from '../../../components/IconLabel.vue'

export default {
  components: {
    'icon-label': iconLabel
  },
  props: {
    isAdvertiser: {
      type: Boolean,
      default: false
    },
    campaign: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'under_construction'
    },
    memberStatus: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loader: false,
      filters: {
        status: 'all'
      }
    }
  },
  computed: {
    aStatuses () {
      return campaignStatuses
    },
    aStatusIndex () {
      return Object.keys(campaignStatuses).indexOf(this.status)
    },
    iStatuses () {
      return memberStatuses
    },
    iStatusIndex () {
      return Object.keys(memberStatuses).indexOf(this.memberStatus)
    }
  },
  created () {
    this.loader = true
  }
}
</script>

<style lang="scss" scoped>
.advertiser-statuses {
  justify-content: space-between;
  @media (max-width: 1180px) {
    justify-content: flex-start;
  }
}
.monochrome {
  filter: grayscale(100%);
}
.status {
  display: inline-block;
  max-width: 200px;
  min-width: 155px;
  width: auto !important;
  margin-top: 0.5em;
}
</style>
